
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import LocalEnvironment from './application/platform/local-environment';
import { LocalEnvironmentSelector } from './presentation/local-environment/local-environment-selector';
import { isModuleLauncher } from './application/platform/module-hostname';
import { ModuleLauncher } from './presentation/module-launcher/module-launcher';

const root = ReactDOM.createRoot(

  document.getElementById('root') as HTMLElement
);

if (isModuleLauncher(window.location.hostname)) {
  // apps-sand.<empresa>: só a lista de módulos, cada um no seu hostname
  root.render(<ModuleLauncher />);
} else if (LocalEnvironment.needsSelection()) {
  // Em localhost sem módulo escolhido: a aplicação não é carregada, pois vários serviços
  // leem os dados do módulo no momento da importação.
  root.render(<LocalEnvironmentSelector />);
} else {
  import('./app-root').then(({ AppRoot }) => root.render(<AppRoot />));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
